//----------with redux-persist------------
import React, { useEffect, useState, useContext } from 'react';
import { useParams, useLocation, useNavigate  } from 'react-router-dom';
import { doubleproductlistData2 } from '../Only2ProductCarousal/data';
import { Link } from 'react-router-dom';
import { useCart } from '../AddToCart/CartContext';
import addtocarticon from '../Images/addtocarticon.png';
import '../HomePage/Home.css';
import './Productdetail.css';
import whatsappicon1 from '../Images/whatsappicon1.png';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import WhatsAppOrderForm from '../WhatsAppOrderForm/WhatsAppOrderForm';
import { useAuth } from '../firebase/AuthContext';

import { DataContext } from "../ProductCarousal1/DataProvider";
import { useSelector } from "react-redux";
import CustomerCare from '../CustomerCare/CustomerCare';

import { useCollection } from '../DashboardProduct/GenericContext';

import ProductDetailSkeleton from './ProductDetailSkeleton';

import CartDrawer from '../AddToCart/CartDrawer';
import { motion } from "framer-motion";

export default function Productdetail() {

  const {loading, loadingMore, loadMoreHomeImprovement, loadMoreElectronicCollection, loadMoreOurCollection, loadMoreTopCollection } = useContext(DataContext);
   
  
    const {homeImprovement}= useSelector(
    (state) => state.homeImprovement
    );
    const {electronicCollection}= useSelector(
    (state) => state.electronicCollection
    );
    const {topCollection}= useSelector(
    (state) => state.topCollection
    );
    const {ourCollection}= useSelector(
      (state) => state.ourCollection
      );
      // const {homeImprovement}= useSelector(
      //   (state) => state.homeImprovement
      //   );
  
  
    // Effect to automatically load more products when reaching the bottom of the page (optional)
    useEffect(() => {
      const observer = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            loadMoreHomeImprovement();
            loadMoreElectronicCollection();
            loadMoreOurCollection();
            loadMoreTopCollection();

          }
        },
        { threshold: 1.0 }
      );
  
      // const bottomHomeImprovement = document.getElementById("homeImprovement-bottom");
      // const bottomElectronicCollection = document.getElementById("electronicCollection-bottom");
      // const bottomTopCollection = document.getElementById("topCollection-bottom");
      // const bottomOurCollection = document.getElementById("ourCollection-bottom");
  
      // if (bottomHomeImprovement) observer.observe(bottomHomeImprovement);
      // if (bottomElectronicCollection) observer.observe(bottomElectronicCollection);
      // if (bottomTopCollection) observer.observe(bottomTopCollection);
      // if (bottomOurCollection) observer.observe(bottomOurCollection);
  
      // return () => {
      //   if (bottomHomeImprovement) observer.unobserve(bottomHomeImprovement);
      //   if (bottomElectronicCollection) observer.unobserve(bottomElectronicCollection);
      //   if (bottomTopCollection) observer.unobserve(bottomTopCollection);
      //   if (bottomOurCollection) observer.unobserve(bottomOurCollection);
      // };
    }, [loading, loadingMore]);



  const navigate = useNavigate();
  const [quantity, setQuantity] = useState(1); 
  const { addToCart, addToCartProductdetail} = useCart();
  const [product, setProduct] = useState(null);
  const [suggestedProducts, setSuggestedProducts] = useState([]);
  const [selectedImageUrl, setSelectedImageUrl] = useState('');
  const [showForm, setShowForm] = useState(false);
  const { id } = useParams();
  const location = useLocation();
  const { handleUserNavigation } = useAuth();


  // const { product:
  const { data: dashboardProducts } = useCollection(); // trendingProducts ab array ho sakta hai

useEffect(() => {
  if (dashboardProducts) {
    // Agar multiple collections hain, toh `find` use karenge
    const foundProduct = Array.isArray(dashboardProducts) 
      ? dashboardProducts.find(item => item?.id === parseInt(id)) 
      : dashboardProducts?.id === parseInt(id) ? dashboardProducts : null;

    if (foundProduct) {
      setProduct(foundProduct);
    }
  }
}, [id, dashboardProducts]);


  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]); 


  //after successful login Redirect user current page mean as it is previous page
  const handleLoginNavigate = () => {
      navigate('/login', { state: { from: location.pathname } });
  };

 
  useEffect(() => {
    if (!dashboardProducts) return;
    const allProducts = [
      ...topCollection,
      ...electronicCollection,
      ...homeImprovement,
      ...ourCollection,
      // ...doubleproductlistData1,
      // ...doubleproductlistData2,
      ...(Array.isArray(dashboardProducts) ? dashboardProducts : [dashboardProducts])
    ];
    if (!allProducts || allProducts.length === 0) return;

    // Update product details
    const newProduct = allProducts.find(product => product.id === parseInt(id));
    if (newProduct !== product) {
      setProduct(newProduct);
    }
    // Update product details


    // multiple product image
    const foundProduct = allProducts.find(p => p.id === parseInt(id));
    setProduct(foundProduct);
    if (foundProduct) {
      setSelectedImageUrl(foundProduct.imageUrl[0]); // Set the first image as default
    }
    // multiple product image

    
    // Get the dataset of the selected product
    // let selectedDataset;
    let selectedDataset = [];
    if (topCollection.some(product => product.id.toString() === id)) {
      selectedDataset = topCollection;
    } else if (electronicCollection.some(product => product.id.toString() === id)) {
      selectedDataset = electronicCollection;
    } else if (homeImprovement.some(product => product.id.toString() === id)) {
      selectedDataset = homeImprovement;
    } 
    else if (ourCollection.some(product => product.id.toString() === id)) {
      selectedDataset = ourCollection;
    } 
    // else if (doubleproductlistData1.some(product => product.id.toString() === id)) {
    //   selectedDataset = doubleproductlistData1;
    // } 
    // else if (doubleproductlistData2.some(product => product.id.toString() === id)) {
    //   selectedDataset = doubleproductlistData2;
    // }
    else if (dashboardProducts.some(product => product.id.toString() === id)) {
      selectedDataset = dashboardProducts;
    }
  
    // Update suggested products
    let newSuggestedProducts = [];
    if (!selectedDataset || selectedDataset.length === 0) return;
    const selectedProductIndex = selectedDataset.findIndex(product => product.id.toString() === id);
    
    if (selectedProductIndex !== -1) {
      for (let i = selectedProductIndex + 5; newSuggestedProducts.length < 4; i += 5) {
        const index = i % selectedDataset.length;
        newSuggestedProducts.push(selectedDataset[index]);
      }
    }
  
    // Limit to 4 products
    newSuggestedProducts = newSuggestedProducts.slice(0, 4);
  
    // Assuming a simple comparison is insufficient, implement a deeper comparison or use a library like lodash for _.isEqual
    if (JSON.stringify(newSuggestedProducts) !== JSON.stringify(suggestedProducts)) {
      setSuggestedProducts(newSuggestedProducts);
    }
  }, [id, topCollection, electronicCollection, homeImprovement, ourCollection, dashboardProducts]);
  // [id, topCollection, electronicCollection, homeImprovement, doubleproductlistData1, doubleproductlistData2]);
   //apny apny data me sy 5 product ky baad 1 product uhtaye ga. asy hi loop chale ga aur 4 product uhta ky may also me show hon gi
  

  const incrementQuantity = () => {
    setQuantity(prev => prev + 1);
  };
  const decrementQuantity = () => {
    setQuantity(prev => prev > 1 ? prev - 1 : 1);
  };
  const handleAddToCart = () => {
    addToCartProductdetail({...product, quantity});
    setIsCartOpen(true); // Open the cart drawer
  };
  const handleCheckout = () => {
    addToCartProductdetail({...product, quantity});
    navigate('/cart');
  };

  // State to control the cart drawer visibility
    const [isCartOpen, setIsCartOpen] = useState(false);
// Function to open the cart drawer
const handleCartDrawer = (product) => {
  addToCart(product);
  setIsCartOpen(true); // Open the cart drawer
};

  // if (!product) {
  //   return <div>Product not found</div>;
  // }
  if (!product) {
    return <ProductDetailSkeleton />; // Show skeleton if product is not available
  }

  // isInstock If Product Quantity Greater than 0
  const isInStock = product.quantity > 0;
  //isInstock If Product Quantity Greater than 0


  //Order On Whatsapp
//   const handleFormSubmit = (formData) => {
//     const message = `------I would like to order this:------\n` +
                    
//                     `Tilte: ${product.title}\n` +
//                     `Item Name: ${product.name}\n` +
//                     `Item ID: ${product.id}\n` +
//                     // `Per Item Price: Rs.${product.price}\n` +
//                     `Item Quantity: ${formData.productQuantity}\n` +
//                     `\n` +
//                     `------Shipping Address------\n` +
//                     `Name: ${formData.name}\n` +
//                     `Email: ${formData.email}\n` +
//                     `Mobile Number: ${formData.mobileNumber}\n` +
//                     `WhatsApp Number: ${formData.whatsappNumber}\n` +
//                     `City: ${formData.city}\n` +
//                     `Province : ${formData.province}\n` +
//                     `Address: ${formData.address}\n` +
//                     `\n`;
//     const encodedMessage = encodeURIComponent(message);
//     const whatsappNumber = "+923265292748";
//     const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
//     window.open(whatsappUrl, "_blank");
//     setShowForm(false); // Close form after submission
// };
// const handleWhatsAppOrderClick = () => {
//     setShowForm(true);
// };
// const handleCloseModal = () => {
//   setShowForm(false);
// };

const handleDirectWhatsAppOrder = () => {
    const message = `*Hello! I want to BUY this product.*\n` +
                    `${product.title} - ` +
                    `${product.name} - ` +
                    `${product.id}\n` +
                    // `${selectedImageUrl}\n` +
                    `Please contact me for further details (payment, shipping, etc.)\n`;
    
    const encodedMessage = encodeURIComponent(message);
    const whatsappNumber = "+923265292748";
    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
    window.open(whatsappUrl, "_blank");
};
  //Order On Whatsapp

const handleProductClick = (Id) => {
  navigate(`/product_detail/${Id}`); // Navigate to the product detail page with the specific product ID
};
 
const responsive = {
  superLargeDesktop: {
    // breakpoint: { max: 4000, min: 1024 },
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
    slidesToSlide: 5,
  },
  desktop: {
    // breakpoint: { max: 1024, min: 768 },
    breakpoint: { max: 3000, min: 1024 },
    items: 4,
    slidesToSlide: 3,
  },
  superLargeTablet: {
    // breakpoint: { max: 768, min: 464 },
    // breakpoint: { max: 1024, min: 464 },
    breakpoint: { max: 1024, min: 700 },
    items: 4,
    slidesToSlide: 3,
  },
  tablet: {
    // breakpoint: { max: 768, min: 464 },
    // breakpoint: { max: 1024, min: 464 },
    breakpoint: { max: 700, min: 464 },
    items: 3,
    slidesToSlide: 3,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 2,
    slidesToSlide: 2,
  }
};


//Auto-Detecting _ as Bullet Points
const formatText = (text) => {
  if (!text) return "No text available";
  // Agar text me bullet points hain (- sy start hoti lines) to list banaye
  if (text.includes(" _ ")) {
    return (
      <ul>
        {text.split(" _ ").map((line, index) =>
          line.trim() ? <li key={index}>{line.trim()}</li> : null
        )}
      </ul>
    );
  }
  
  return <p>{text}</p>;
};
//Auto-Detecting _ as Bullet Points


  return (
    <>
      {/* -----------------Product Detail Section------------------------- */}
      <motion.div className='product-detail-container' initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
          {/* <div style={{display:'flex'}}> */}
          {/* <img src={product.imageUrl} alt={product.name} className='product-image'/> */}
          <div className='product-info-container'>
            <motion.div 
              className='product-info-images'
              initial={{ x: -50, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ delay: 0.2, duration: 0.5 }}
            >
              {/* ----------------multiple product image--------------- */}
              <div className="image-selector" >
                {product.imageUrl.map((url, index) => (
                  <motion.img
                    key={index}
                    src={url}
                    alt={`Thumbnail ${index}`}
                    className="thumbnail"
                    onClick={() => setSelectedImageUrl(url)}
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                  />
                ))}
              </div>
              {/* ----------------multiple product image--------------- */}
              <motion.img 
                src={selectedImageUrl} 
                alt={product.name} 
                className='product-image'
                key={selectedImageUrl}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3 }}
              />
            </motion.div>
          
            <motion.div 
              className='name-price-stock-btn-container'
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.3, duration: 0.5 }}
            >
              <div className='name-price-stock-info'>
                <h2 className='product-deatil-product-name'>{product.name}</h2>
                <p className='product-detail-product-id'>Product id: {product.id}</p>
                {/* <p className='product-detail-product-price'>Rs.{product.price}</p> */}
                <div>
                  {product.discountPrice && product.discountPrice > 0 ? (
                    <>
                      <p className="product-detail-product-price">
                        Rs. {product.price}
                      </p>
                      <p className="product-detail-product-discount-price">
                        Rs. {product.discountPrice}
                      </p>
                    </>
                  ) : (
                        <p className="product-detail-product-discount-price">Rs.{product.price}</p>
                      )}
                </div>
              
                {/* ----------In Stock Green Light and Out of Stock Red Light Code ---------- */}
                <motion.p whileHover={{ scale: 1.02 }}>
                  {isInStock ? (
                    <>
                      <div  className='green-light-container'>
                        <motion.div 
                          className="green-light"
                          animate={{ 
                            scale: [1, 1.1, 1],
                            opacity: [0.8, 1, 0.8]
                          }}
                          transition={{ 
                            repeat: Infinity, 
                            duration: 2 
                          }}
                        ></motion.div>
                        <span className='green-light-content'>In Stock</span>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className='red-light-container'>
                        <motion.div 
                          className="red-light"
                          animate={{ 
                            scale: [1, 1.1, 1],
                            opacity: [0.8, 1, 0.8]
                          }}
                          transition={{ 
                            repeat: Infinity, 
                            duration: 2 
                          }}
                        ></motion.div>
                        <span className='red-light-content'>Out of Stock</span>
                      </div>
                    </>
                  )}
                </motion.p>
                {/* ----------In Stock Green Light and Out of Stock Red Light Code ---------- */}
              </div>

              <label className='quantity-label'>Quantity</label>

              <div className='product-btn-info'>
                {/* -------------Increament Quantity and Decreament Quantity Code------------ */}
                <motion.div 
                  className='fancy-btn-container'
                  whileHover={{ scale: 1.02 }}
                >
              
                  <motion.button 
                    onClick={incrementQuantity} 
                    className={`fancy-increment-btn ${!isInStock ? 'disabled' : ''}`} 
                    disabled={!isInStock}
                    whileTap={{ scale: 0.95 }}
                  >
                    +
                  </motion.button>

                  {isInStock ? (
                    <motion.span  
                      className='quantity'
                      
                      key={quantity}
                      initial={{ scale: 0.8 }}
                      animate={{ scale: 1 }}
                    >
                      {quantity}
                    </motion.span >
                  ) : (
                    <span style={{ opacity: 0.5 }} className='quantity'>0</span>
                  )}

                  <motion.button 
                    onClick={decrementQuantity} 
                    className={`fancy-decrement-btn ${!isInStock ? 'disabled' : ''}`} 
                    disabled={!isInStock}
                    whileTap={{ scale: 0.95 }}
                  >
                    -
                  </motion.button>
                </motion.div>
                {/* -------------Increament Quantity and Decreament Quantity Code------------ */}

                {/* ----------Add to Cart, Checkout and Order on Whatsapp Buttons ------------*/}

                <motion.button 
                  onClick={handleAddToCart} 
                  className={`fancy ${!isInStock ? 'disabled' : ''}`} 
                  disabled={!isInStock}
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  <span className="top-key"></span>
                  <span className='text' >
                    {/* <img src={addtocarticon} alt="AddtoCartIconError" style={{width:'2.5vmax', height:'2.2vmax'}}/> */}
                    <i class="ri-shopping-cart-2-line" />  
                    Add to Cart
                  </span>
                  <span className="bottom-key-1"></span>
                  <span className="bottom-key-2"></span>
                </motion.button>

                <Link to='/ordernow' style={{textDecoration: 'none'}} className={!isInStock ? 'disabled' : ''}>
                  <motion.button 
                    onClick={handleCheckout} 
                    className="fancy" 
                    style={{background:'linear-gradient(to right, #000000 0%, #434343  51%, #000000  100%)'}}
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                  >
                    <span className="top-key"></span>
                    <span className='text' style={{color:'white'}}>
                      <i class="ri-shopping-bag-line" />
                      Checkout
                    </span>
                    <span className="bottom-key-1"></span>
                    <span className="bottom-key-2"></span>
                  </motion.button>
                </Link>

                <motion.button 
                  // onClick={handleWhatsAppOrderClick} 
                  onClick={handleDirectWhatsAppOrder}
                  style={{    background: 'linear-gradient(45deg, #050f2c, #003666, #00aeff, #336900, #8e43e7, #b84592)'}} 
                  className={`fancy ${!isInStock ? 'disabled' : ''}`} 
                  disabled={!isInStock}
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  <span className="top-key"></span>
                  <span className='text' style={{color:'white'}}>
                    {/* <img src={whatsappicon1} style={{width:'2rem',height:'2rem'}}/> */}
                    <i class="ri-whatsapp-fill" />
                    Order on WhatsApp
                  </span>
                  <span className="bottom-key-1"></span>
                  <span className="bottom-key-2"></span>
                </motion.button>
                {/* {showForm && <WhatsAppOrderForm onSubmit={handleFormSubmit} onClose={handleCloseModal} />} */}
              </div> 
            </motion.div >
          {/* </div> */}
          {/* ----------Add to Cart, Checkout and Order on Whatsapp Buttons ------------*/}
          </div>
        
          {/* <h2 className='description-heading'>Product Description</h2>
          <p className='description-content'>{product.description}</p> */}

          {/* <div className="description-container">
            <h2 className='description-heading'>{product.descriptionHeading[0]}</h2>
            <p className='description-content'>{product.descriptionHeadingText[0]}</p>
            {product.descriptionHeading?.slice(1).map((heading, index) => (
              <div key={index} className="description-item">
                <h3 className="description-sub-heading">{heading}</h3>
                <p className="description-sub-content">{product.descriptionHeadingText?.slice(1)[index]}</p>
              </div>
            ))}
          </div> */}
          <motion.div 
            className="description-container"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 }}
          >
            <h2 className="description-heading">{product.descriptionHeading[0]}</h2>
            <p className='description-content'>{formatText(product.descriptionHeadingText[0])}</p>
            {product.descriptionHeading?.slice(1).map((heading, index) => (
              <motion.div  
                key={index} 
                className="description-item"
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.5 + index * 0.1 }}
              >
                <h3 className="description-sub-heading">{heading}</h3>
                <p className='description-sub-content'>{formatText(product.descriptionHeadingText?.slice(1)[index])}</p>
              </motion.div >
            ))}
          </motion.div>

          <motion.div 
            className="description-product-image-container"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.6 }}
          >
            {product.descriptionImageUrl?.map((image, index) => (
              <motion.img 
                key={index} 
                src={image} 
                alt={`Image ${index + 1}`} 
                className="description-product-Image" 
                whileHover={{ scale: 1.02 }}
                transition={{ type: "spring", stiffness: 400, damping: 10 }}
              />
            ))}
          </motion.div >

          <motion.div 
            className='product-video'
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.7 }}
          >
            {/* {product.videoLink} */}
            <iframe
              width="100%"
              height="100%"
              src={product.videoLink} // Firebase se fetched video link
              title={product.name}
              frameBorder="0"
             allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
             allowFullScreen
             loading="eager"
            ></iframe>
          </motion.div>

          {/* -----------Draw Text 2 Sided line code--------------- */}
          <motion.div 
            className="text-container"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.8 }}
          >
            <div className="horizontal-line"></div>
            <h3>🔥 You May Also Like 🔥</h3>
            <div className="horizontal-line"></div>
          </motion.div>
          {/* -----------Draw Text 2 Sided line code-------------- */}

          {/* ------------------"You May Also Like" section----------------- */}
          <Carousel responsive={responsive}>
            {suggestedProducts.map(product => (
              <motion.div 
                key={product.id} 
                onClick={() => handleProductClick(product.id)}
                className="SuggestionsCard"
                whileHover={{ scale: 1.03 }}
                whileTap={{ scale: 0.97 }}
              >
                {/* <Link to={`/product_detail/${product.id}`} className='SuggestionsProductDetailLink'> */}
                <motion.img 
                  className="SuggestionsProduct--image" 
                  src={product.imageUrl[0]} 
                  alt={product.name} 
                  whileHover={{ scale: 1.05 }}
                />
                <h3 className="SuggestionsName">{product.title}</h3>
                {/* <p className="SuggestionsPrice">Rs.{product.price}</p> */}
                <div>
                  {product.discountPrice && product.discountPrice > 0 ? (
                    <>
                      <p className="SuggestionsPrice">
                        Rs. {product.price}
                      </p>
                      <p className="SuggestionsDiscountPrice">
                        Rs. {product.discountPrice}
                      </p>
                    </>
                  ) : (
                        <p className="SuggestionsDiscountPrice">
                          Rs.{product.price}
                        </p>
                      )}
                </div>
                {/* </Link> */}
                <motion.button 
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent triggering the product click event
                    // addToCart(product)
                    handleCartDrawer(product)
                  }}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  {/* onClick={() => addToCart(product)}> */}
                  Add to Cart
                </motion.button>
              </motion.div>
            ))}
          </Carousel>
          {/* ------------------"You May Also Like" section----------------- */}
      </motion.div>
      {/* -----------------Product Detail Section------------------------- */}
      
      <CustomerCare />

      {/* Cart Drawer */}
      <CartDrawer isOpen={isCartOpen} onClose={() => setIsCartOpen(false)} />
    </>
  );
}




//----------with redux-persist------------
//---------with search-bar
// import React, { useEffect, useState, useContext } from 'react';
// import { useParams, useLocation, useNavigate  } from 'react-router-dom';
// import { topCollection, electronicCollection, homeImprovement } from '../ProductCarousal1/data';
// import { doubleproductlistData1, doubleproductlistData2 } from '../Only2ProductCarousal/data';
// import { Link } from 'react-router-dom';
// import { useCart } from '../AddToCart/CartContext';
// import addtocarticon from '../Images/addtocarticon.png';
// import searchicon from '../Images/searchicon.png';
// import '../HomePage/Home.css';
// import './Productdetail.css';
// import Searchproduct from '../SearchProduct/Searchproduct';
// import whatsappicon1 from '../Images/whatsappicon1.png';
// import usericon from '../Images/usericon.png'
// import Carousel from 'react-multi-carousel';
// import 'react-multi-carousel/lib/styles.css';
// import WhatsAppOrderForm from '../WhatsAppOrderForm/WhatsAppOrderForm';
// import { useAuth } from '../firebase/AuthContext';

// import { DataContext } from "../ProductCarousal1/DataProvider";
// import { useSelector } from "react-redux";


// export default function Productdetail() {

//   const {loading, loadingMore, loadMoreHomeImprovement, loadMoreElectronicCollection, loadMoreOurCollection } = useContext(DataContext);
   
  
//     const {homeImprovement}= useSelector(
//     (state) => state.homeImprovement
//     );
//     const {electronicCollection}= useSelector(
//     (state) => state.electronicCollection
//     );
//     const {topCollection}= useSelector(
//     (state) => state.topCollection
//     );
//     const {ourCollection}= useSelector(
//       (state) => state.ourCollection
//       );
//       // const {homeImprovement}= useSelector(
//       //   (state) => state.homeImprovement
//       //   );
  
  
//     // Effect to automatically load more products when reaching the bottom of the page (optional)
//     useEffect(() => {
//       const observer = new IntersectionObserver(
//         (entries) => {
//           if (entries[0].isIntersecting) {
//             loadMoreHomeImprovement();
//             loadMoreElectronicCollection();
//           }
//         },
//         { threshold: 1.0 }
//       );
  
//       // const bottomHomeImprovement = document.getElementById("homeImprovement-bottom");
//       // const bottomElectronicCollection = document.getElementById("electronicCollection-bottom");
//       // const bottomTopCollection = document.getElementById("topCollection-bottom");
  
//       // if (bottomHomeImprovement) observer.observe(bottomHomeImprovement);
//       // if (bottomElectronicCollection) observer.observe(bottomElectronicCollection);
//       // if (bottomTopCollection) observer.observe(bottomTopCollection);
  
//       // return () => {
//       //   if (bottomHomeImprovement) observer.unobserve(bottomHomeImprovement);
//       //   if (bottomElectronicCollection) observer.unobserve(bottomElectronicCollection);
//       //   if (bottomTopCollection) observer.unobserve(bottomTopCollection);
//       // };
//     }, [loading, loadingMore]);



//   const navigate = useNavigate();
//   const [quantity, setQuantity] = useState(1);
//   const { cartItemCount } = useCart(); 
//   const { addToCart, addToCartProductdetail} = useCart();
//   const [product, setProduct] = useState(null);
//   const [suggestedProducts, setSuggestedProducts] = useState([]);
//   const [selectedImageUrl, setSelectedImageUrl] = useState('');
//   const [showForm, setShowForm] = useState(false);
//   const { id } = useParams();
//   const location = useLocation();
//   const { handleUserNavigation } = useAuth();


//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, [location]); 


//   //after successful login Redirect user current page mean as it is previous page
//   const handleLoginNavigate = () => {
//       navigate('/login', { state: { from: location.pathname } });
//   };

 
//   useEffect(() => {
//     const allProducts = [
//       ...topCollection,
//       ...electronicCollection,
//       ...homeImprovement,
//       ...ourCollection,
//       // ...doubleproductlistData1,
//       ...doubleproductlistData2
//     ];
  

//     // Update product details
//     const newProduct = allProducts.find(product => product.id === parseInt(id));
//     if (newProduct !== product) {
//       setProduct(newProduct);
//     }
//     // Update product details


//     // multiple product image
//     const foundProduct = allProducts.find(p => p.id === parseInt(id));
//     setProduct(foundProduct);
//     if (foundProduct) {
//       setSelectedImageUrl(foundProduct.imageUrl[0]); // Set the first image as default
//     }
//     // multiple product image

    
//     // Get the dataset of the selected product
//     let selectedDataset;
//     if (topCollection.some(product => product.id.toString() === id)) {
//       selectedDataset = topCollection;
//     } else if (electronicCollection.some(product => product.id.toString() === id)) {
//       selectedDataset = electronicCollection;
//     } else if (homeImprovement.some(product => product.id.toString() === id)) {
//       selectedDataset = homeImprovement;
//     } else if (ourCollection.some(product => product.id.toString() === id)) {
//       selectedDataset = ourCollection;
//     } 
//     // else if (doubleproductlistData1.some(product => product.id.toString() === id)) {
//     //   selectedDataset = doubleproductlistData1;
//     // } 
//     else if (doubleproductlistData2.some(product => product.id.toString() === id)) {
//       selectedDataset = doubleproductlistData2;
//     }
  
//     // Update suggested products
//     let newSuggestedProducts = [];
//     const selectedProductIndex = selectedDataset.findIndex(product => product.id.toString() === id);
    
//     if (selectedProductIndex !== -1) {
//       for (let i = selectedProductIndex + 5; newSuggestedProducts.length < 4; i += 5) {
//         const index = i % selectedDataset.length;
//         newSuggestedProducts.push(selectedDataset[index]);
//       }
//     }
  
//     // Limit to 4 products
//     newSuggestedProducts = newSuggestedProducts.slice(0, 4);
  
//     // Assuming a simple comparison is insufficient, implement a deeper comparison or use a library like lodash for _.isEqual
//     if (JSON.stringify(newSuggestedProducts) !== JSON.stringify(suggestedProducts)) {
//       setSuggestedProducts(newSuggestedProducts);
//     }
//   }, [id, topCollection, electronicCollection, homeImprovement, ourCollection, doubleproductlistData2]);
//   // [id, topCollection, electronicCollection, homeImprovement, doubleproductlistData1, doubleproductlistData2]);
//    //apny apny data me sy 5 product ky baad 1 product uhtaye ga. asy hi loop chale ga aur 4 product uhta ky may also me show hon gi
  

//   const incrementQuantity = () => {
//     setQuantity(prev => prev + 1);
//   };
//   const decrementQuantity = () => {
//     setQuantity(prev => prev > 1 ? prev - 1 : 1);
//   };
//   const handleAddToCart = () => {
//     addToCartProductdetail({...product, quantity});
//   };
//   const handleCheckout = () => {
//     addToCartProductdetail({...product, quantity});
//     navigate('/cart');
//   };


//   if (!product) {
//     return <div>Product not found</div>;
//   }

//   // isInstock If Product Quantity Greater than 0
//   const isInStock = product.quantity > 0;
//   //isInstock If Product Quantity Greater than 0


//   //Order On Whatsapp
//   const handleFormSubmit = (formData) => {
//     const message = `----------I would like to order this:-----------\n` +
                    
//                     `Item Name: ${product.name}\n` +
//                     `Item ID: ${product.id}\n` +
//                     // `Per Item Price: Rs.${product.price}\n` +
//                     `Item Quantity: ${formData.productQuantity}\n` +
//                     `\n` +
//                     `----------Shipping Address----------\n` +
//                     `Name: ${formData.name}\n` +
//                     `Email: ${formData.email}\n` +
//                     `Mobile Number: ${formData.mobileNumber}\n` +
//                     `WhatsApp Number: ${formData.whatsappNumber}\n` +
//                     `Address: ${formData.address}\n` +
//                     `\n`;
//     const encodedMessage = encodeURIComponent(message);
//     const whatsappNumber = "+923091416573";
//     const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
//     window.open(whatsappUrl, "_blank");
//     setShowForm(false); // Close form after submission
// };
// const handleWhatsAppOrderClick = () => {
//     setShowForm(true);
// };
// const handleCloseModal = () => {
//   setShowForm(false);
// };
 
// const responsive = {
//   superLargeDesktop: {
//     breakpoint: { max: 4000, min: 1024 },
//     items: 3,
//     slidesToSlide: 3,
//   },
//   desktop: {
//     breakpoint: { max: 1024, min: 768 },
//     items: 3,
//     slidesToSlide: 3,
//   },
//   tablet: {
//     breakpoint: { max: 768, min: 464 },
//     items: 2,
//     slidesToSlide: 2,
//   },
//   mobile: {
//     breakpoint: { max: 464, min: 0 },
//     items: 2,
//     slidesToSlide: 2,
//   }
// };


//   return (
//     <>
//       {/*------------Search Product and cart, cartItemCount, login Section---------------*/}
//       <div className='home-page-container'>
        
//         {/* -------------Search Product code-------------- */}
//         <div style={{display:'flex'}}>
//           <Searchproduct productData={[...topCollection, ...electronicCollection, ...homeImprovement, ...ourCollection, ...doubleproductlistData2]} />
//           {/* <Searchproduct productData={[...topCollection, ...electronicCollection, ...homeImprovement, ...doubleproductlistData1, ...doubleproductlistData2]} /> */}
//           {/* <img src={searchicon} alt="SearchIconError" style={{width:'2.5vmax', height:'2vmax', marginBottom:'3.5px'}}/> */}
//         </div>
//         {/* -------------Search Product code-------------- */}

//         {/* -------cart, cartItemCount, login code-------- */}
//         <div  style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
//           <Link to="/cart" className='cart-link'>{cartItemCount > 0 && <span className="cart-count" >{cartItemCount}</span>}<img src={addtocarticon} alt="AddtoCartIconError" style={{width:'4.2vmax', height:'3.5vmax',minWidth: '42px', minHeight: '30px'}}/></Link>
//           <img src={usericon} alt="Login" onClick={handleUserNavigation} style={{width:'6.2vmax', height:'4.5vmax', cursor: 'pointer', minWidth:'53px', minHeight:'38px'}} className='user-image'/>

//         </div>
//         {/* -------cart, cartItemCount, login code-------- */}

//       </div>
//       {/*------------Search Product and cart, cartItemCount, login Section---------------*/}
      



//       {/* -----------------Product Detail Section------------------------- */}
//       <div className='product-detail-container'>
//         <div style={{display:'flex'}}>
//           {/* <img src={product.imageUrl} alt={product.name} className='product-image'/> */}
//           <div className='images-container'>
//           <img src={selectedImageUrl} alt={product.name} className='product-image'/>
//           {/* ----------------multiple product image--------------- */}
//           <div className="image-selector" >
//             {product.imageUrl.map((url, index) => (
//               <img
//                 key={index}
//                 src={url}
//                 alt={`Thumbnail ${index}`}
//                 className="thumbnail"
//                onClick={() => setSelectedImageUrl(url)}
//               />
//             ))}
//           </div>
//         </div>
//         {/* ----------------multiple product image--------------- */}
//           <div style={{marginLeft:'5%'}}>
//             <h2 style={{wordWrap:'break-word'}}>{product.name}</h2>
//             <p style={{fontSize:'large', fontStyle:'oblique'}}>Rs.{product.price}</p>


//             {/* ----------In Stock Green Light and Out of Stock Red Light Code ---------- */}

//             <p >
//               {isInStock ? (
//                 <>
//                   <div  className='green-light-container'>
//                     <div className="green-light" ></div>
//                     <span className='green-light-content'>In Stock</span>
//                   </div>
//                 </>
//               ) : (
//                 <>
//                   <div className='red-light-container'>
//                     <div className="red-light"></div>
//                     <span className='red-light-content'>Out of Stock</span>
//                   </div>
//                 </>
//               )}
//             </p>
//             {/* ----------In Stock Green Light and Out of Stock Red Light Code ---------- */}

           


//             {/* -------------Increament Quantity and Decreament Quantity Code------------ */}
  
//             <div className='fancy-btn-container'>
//               <button onClick={incrementQuantity} className={`fancy-increment-btn ${!isInStock ? 'disabled' : ''}`} disabled={!isInStock}>
//                 +
//               </button>
//               {isInStock ? (
//                 <span className='quantity'>
//                   {quantity}
//                 </span>
//               ) : (
//                 <span style={{ opacity: 0.5 }} className='quantity'>0</span>
//               )}
//               <button onClick={decrementQuantity} className={`fancy-decrement-btn ${!isInStock ? 'disabled' : ''}`} disabled={!isInStock}>
//                 -
//               </button>
//             </div>

//             {/* -------------Increament Quantity and Decreament Quantity Code------------ */}





//             {/* ----------Add to Cart, Checkout and Order on Whatsapp Buttons ------------*/}

//             <button onClick={handleAddToCart} className={`fancy ${!isInStock ? 'disabled' : ''}`} disabled={!isInStock}>
//               <span className="top-key"></span>
//               <span className='text' >
//               <img src={addtocarticon} alt="AddtoCartIconError" style={{width:'2.5vmax', height:'2.2vmax'}}/>
//                 Add to Cart
//               </span>
//               <span className="bottom-key-1"></span>
//               <span className="bottom-key-2"></span>
//             </button>

            
//             <Link to='/ordernow' style={{textDecoration: 'none'}} className={!isInStock ? 'disabled' : ''}>
//               <button onClick={handleCheckout} className="fancy">
//                 <span className="top-key"></span>
//                 <span className='text'>Checkout</span>
//                 <span className="bottom-key-1"></span>
//                 <span className="bottom-key-2"></span>
//               </button>
//             </Link>


//             <button onClick={handleWhatsAppOrderClick} className={`fancy ${!isInStock ? 'disabled' : ''}`} disabled={!isInStock}>
//               <span className="top-key"></span>
//               <span className='text'>
//                 <img src={whatsappicon1} style={{width:'2rem',height:'2rem'}}/>
//                 Order on WhatsApp
//               </span>
//               <span className="bottom-key-1"></span>
//               <span className="bottom-key-2"></span>
//             </button>
//             {showForm && <WhatsAppOrderForm onSubmit={handleFormSubmit} onClose={handleCloseModal} />}
            
//           </div>
//         </div>
//         {/* ----------Add to Cart, Checkout and Order on Whatsapp Buttons ------------*/}




//         <h2 className='description'>Description:</h2>
//         <p>{product.description}</p>
//         <div className='product-video'>
//           {/* {product.videoLink} */}
//           <iframe
//           width="100%"
//           height="100%"
//           src={product.videoLink} // Firebase se fetched video link
//           title={product.name}
//           frameBorder="0"
//           allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
//           allowFullScreen
//         ></iframe>
//         </div>
//       </div>
//       {/* -----------------Product Detail Section------------------------- */}
      


//       {/* -----------Draw Text 2 Sided line code--------------- */}
//         <div className="text-container">
//           <div className="horizontal-line"></div>
//           <h3>🔥 You May Also Like 🔥</h3>
//           <div className="horizontal-line"></div>
//         </div>
//       {/* -----------Draw Text 2 Sided line code-------------- */}




//       {/* ------------------"You May Also Like" section----------------- */}
//         <Carousel responsive={responsive} containerClass="carousel-container">
//           {suggestedProducts.map(product => (
//             <div key={product.id} className="SuggestionsCard">
//               <Link to={`/product_detail/${product.id}`} className='SuggestionsProductDetailLink'>
//                 <img className="SuggestionsProduct--image" src={product.imageUrl} alt={product.name} />
//                 <h3 className="SuggestionsName">{product.name}</h3>
//                 <p className="SuggestionsPrice">Rs.{product.price}</p>
//               </Link>
//               <button onClick={() => addToCart(product)}>Add to Cart</button>
//             </div>
//           ))}
//         </Carousel>
//       {/* ------------------"You May Also Like" section----------------- */}
     
//     </>
//   );
// }






//----------original---------------
// import React, { useEffect, useState } from 'react';
// import { useParams, useLocation, useNavigate  } from 'react-router-dom';
// import { topCollection, electronicCollection, homeImprovement } from '../ProductCarousal1/data';
// import { doubleproductlistData1, doubleproductlistData2 } from '../Only2ProductCarousal/data';
// import { Link } from 'react-router-dom';
// import { useCart } from '../AddToCart/CartContext';
// import addtocarticon from '../Images/addtocarticon.png';
// import searchicon from '../Images/searchicon.png';
// import '../HomePage/Home.css';
// import './Productdetail.css';
// import Searchproduct from '../SearchProduct/Searchproduct';
// import whatsappicon1 from '../Images/whatsappicon1.png';
// import usericon from '../Images/usericon.png'
// import Carousel from 'react-multi-carousel';
// import 'react-multi-carousel/lib/styles.css';
// import WhatsAppOrderForm from '../WhatsAppOrderForm/WhatsAppOrderForm';
// import { useAuth } from '../firebase/AuthContext';


// export default function Productdetail() {

//   const navigate = useNavigate();
//   const [quantity, setQuantity] = useState(1);
//   const { cartItemCount } = useCart(); 
//   const { addToCart, addToCartProductdetail} = useCart();
//   const [product, setProduct] = useState(null);
//   const [suggestedProducts, setSuggestedProducts] = useState([]);
//   const [selectedImageUrl, setSelectedImageUrl] = useState('');
//   const [showForm, setShowForm] = useState(false);
//   const { id } = useParams();
//   const location = useLocation();
//   const { handleUserNavigation } = useAuth();


//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, [location]); 


//   //after successful login Redirect user current page mean as it is previous page
//   const handleLoginNavigate = () => {
//       navigate('/login', { state: { from: location.pathname } });
//   };

 
//   useEffect(() => {
//     const allProducts = [
//       ...topCollection,
//       ...electronicCollection,
//       ...homeImprovement,
//       ...doubleproductlistData1,
//       ...doubleproductlistData2
//     ];
  

//     // Update product details
//     const newProduct = allProducts.find(product => product.id === parseInt(id));
//     if (newProduct !== product) {
//       setProduct(newProduct);
//     }
//     // Update product details


//     // multiple product image
//     const foundProduct = allProducts.find(p => p.id === parseInt(id));
//     setProduct(foundProduct);
//     if (foundProduct) {
//       setSelectedImageUrl(foundProduct.imageUrl[0]); // Set the first image as default
//     }
//     // multiple product image

    
//     // Get the dataset of the selected product
//     let selectedDataset;
//     if (topCollection.some(product => product.id.toString() === id)) {
//       selectedDataset = topCollection;
//     } else if (electronicCollection.some(product => product.id.toString() === id)) {
//       selectedDataset = electronicCollection;
//     } else if (homeImprovement.some(product => product.id.toString() === id)) {
//       selectedDataset = homeImprovement;
//     } else if (doubleproductlistData1.some(product => product.id.toString() === id)) {
//       selectedDataset = doubleproductlistData1;
//     } else if (doubleproductlistData2.some(product => product.id.toString() === id)) {
//       selectedDataset = doubleproductlistData2;
//     }
  
//     // Update suggested products
//     let newSuggestedProducts = [];
//     const selectedProductIndex = selectedDataset.findIndex(product => product.id.toString() === id);
    
//     if (selectedProductIndex !== -1) {
//       for (let i = selectedProductIndex + 5; newSuggestedProducts.length < 4; i += 5) {
//         const index = i % selectedDataset.length;
//         newSuggestedProducts.push(selectedDataset[index]);
//       }
//     }
  
//     // Limit to 4 products
//     newSuggestedProducts = newSuggestedProducts.slice(0, 4);
  
//     // Assuming a simple comparison is insufficient, implement a deeper comparison or use a library like lodash for _.isEqual
//     if (JSON.stringify(newSuggestedProducts) !== JSON.stringify(suggestedProducts)) {
//       setSuggestedProducts(newSuggestedProducts);
//     }
//   }, [id, topCollection, electronicCollection, homeImprovement, doubleproductlistData1, doubleproductlistData2]);
//    //apny apny data me sy 5 product ky baad 1 product uhtaye ga. asy hi loop chale ga aur 4 product uhta ky may also me show hon gi
  

//   const incrementQuantity = () => {
//     setQuantity(prev => prev + 1);
//   };
//   const decrementQuantity = () => {
//     setQuantity(prev => prev > 1 ? prev - 1 : 1);
//   };
//   const handleAddToCart = () => {
//     addToCartProductdetail({...product, quantity});
//   };
//   const handleCheckout = () => {
//     addToCartProductdetail({...product, quantity});
//     navigate('/cart');
//   };


//   if (!product) {
//     return <div>Product not found</div>;
//   }

//   // isInstock If Product Quantity Greater than 0
//   const isInStock = product.quantity > 0;
//   //isInstock If Product Quantity Greater than 0


//   //Order On Whatsapp
//   const handleFormSubmit = (formData) => {
//     const message = `----------I would like to order this:-----------\n` +
                    
//                     `Item Name: ${product.name}\n` +
//                     `Item ID: ${product.id}\n` +
//                     // `Per Item Price: Rs.${product.price}\n` +
//                     `Item Quantity: ${formData.productQuantity}\n` +
//                     `\n` +
//                     `----------Shipping Address----------\n` +
//                     `Name: ${formData.name}\n` +
//                     `Email: ${formData.email}\n` +
//                     `Mobile Number: ${formData.mobileNumber}\n` +
//                     `WhatsApp Number: ${formData.whatsappNumber}\n` +
//                     `Address: ${formData.address}\n` +
//                     `\n`;
//     const encodedMessage = encodeURIComponent(message);
//     const whatsappNumber = "+923091416573";
//     const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
//     window.open(whatsappUrl, "_blank");
//     setShowForm(false); // Close form after submission
// };
// const handleWhatsAppOrderClick = () => {
//     setShowForm(true);
// };
// const handleCloseModal = () => {
//   setShowForm(false);
// };
 
// const responsive = {
//   superLargeDesktop: {
//     breakpoint: { max: 4000, min: 1024 },
//     items: 3,
//     slidesToSlide: 3,
//   },
//   desktop: {
//     breakpoint: { max: 1024, min: 768 },
//     items: 3,
//     slidesToSlide: 3,
//   },
//   tablet: {
//     breakpoint: { max: 768, min: 464 },
//     items: 2,
//     slidesToSlide: 2,
//   },
//   mobile: {
//     breakpoint: { max: 464, min: 0 },
//     items: 2,
//     slidesToSlide: 2,
//   }
// };


//   return (
//     <>
//       {/*------------Search Product and cart, cartItemCount, login Section---------------*/}
//       <div className='Part2'>
        
//         {/* -------------Search Product code-------------- */}
//         <div style={{display:'flex'}}>
//           <Searchproduct productData={[...topCollection, ...electronicCollection, ...homeImprovement, ...doubleproductlistData1, ...doubleproductlistData2]} />
//           <img src={searchicon} alt="SearchIconError" style={{width:'2.5vmax', height:'2vmax', marginBottom:'3.5px'}}/>
//         </div>
//         {/* -------------Search Product code-------------- */}

//         {/* -------cart, cartItemCount, login code-------- */}
//         <div  style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
//           <Link to="/cart" className='link2'>{cartItemCount > 0 && <span className="cart-count" >{cartItemCount}</span>}<img src={addtocarticon} alt="AddtoCartIconError" style={{width:'3vmax', height:'2.5vmax'}}/></Link>
//           <img src={usericon} alt="Login" onClick={handleUserNavigation} style={{width:'5vmax', height:'3.5vmax'}} className='userimage'/>

//         </div>
//         {/* -------cart, cartItemCount, login code-------- */}

//       </div>
//       {/*------------Search Product and cart, cartItemCount, login Section---------------*/}
      



//       {/* -----------------Product Detail Section------------------------- */}
//       <div className='productDetail'>
//         <div style={{display:'flex'}}>
//           {/* <img src={product.imageUrl} alt={product.name} className='product-image'/> */}
//           <div className='images-container'>
//           <img src={selectedImageUrl} alt={product.name} className='product-image'/>
//           {/* ----------------multiple product image--------------- */}
//         <div className="image-selector" >
//           {product.imageUrl.map((url, index) => (
//             <img
//               key={index}
//               src={url}
//               alt={`Thumbnail ${index}`}
//               className="thumbnail"
//               onClick={() => setSelectedImageUrl(url)}
//            />
//           ))}
//         </div>
//         </div>
//         {/* ----------------multiple product image--------------- */}
//           <div style={{marginLeft:'5%'}}>
//             <h2 style={{wordWrap:'break-word'}}>{product.name}</h2>
//             <p style={{fontSize:'large', fontStyle:'oblique'}}>Rs.{product.price}</p>


//             {/* ----------In Stock Green Light and Out of Stock Red Light Code ---------- */}

//             <p >
//               {isInStock ? (
//                 <>
//                   <div  className='green-light-container'>
//                     <div className="green-light" ></div>
//                     <span className='green-light-content'>In Stock</span>
//                   </div>
//                 </>
//               ) : (
//                 <>
//                   <div className='red-light-container'>
//                     <div className="red-light"></div>
//                     <span className='red-light-content'>Out of Stock</span>
//                   </div>
//                 </>
//               )}
//             </p>
//             {/* ----------In Stock Green Light and Out of Stock Red Light Code ---------- */}

           


//             {/* -------------Increament Quantity and Decreament Quantity Code------------ */}
  
//             <div className='fancy-btn-container'>
//               <button onClick={incrementQuantity} className={`fancy-increment-btn ${!isInStock ? 'disabled' : ''}`} disabled={!isInStock}>
//                 +
//               </button>
//               {isInStock ? (
//                 <span className='quantity'>
//                   {quantity}
//                 </span>
//               ) : (
//                 <span style={{ opacity: 0.5 }} className='quantity'>0</span>
//               )}
//               <button onClick={decrementQuantity} className={`fancy-decrement-btn ${!isInStock ? 'disabled' : ''}`} disabled={!isInStock}>
//                 -
//               </button>
//             </div>

//             {/* -------------Increament Quantity and Decreament Quantity Code------------ */}





//             {/* ----------Add to Cart, Checkout and Order on Whatsapp Buttons ------------*/}

//             <button onClick={handleAddToCart} className={`fancy ${!isInStock ? 'disabled' : ''}`} disabled={!isInStock}>
//               <span className="top-key"></span>
//               <span className='text' >
//               <img src={addtocarticon} alt="AddtoCartIconError" style={{width:'2.5vmax', height:'2.2vmax'}}/>
//                 Add to Cart
//               </span>
//               <span className="bottom-key-1"></span>
//               <span className="bottom-key-2"></span>
//             </button>

            
//             <Link to='/ordernow' style={{textDecoration: 'none'}} className={!isInStock ? 'disabled' : ''}>
//               <button onClick={handleCheckout} className="fancy">
//                 <span className="top-key"></span>
//                 <span className='text'>Checkout</span>
//                 <span className="bottom-key-1"></span>
//                 <span className="bottom-key-2"></span>
//               </button>
//             </Link>


//             <button onClick={handleWhatsAppOrderClick} className={`fancy ${!isInStock ? 'disabled' : ''}`} disabled={!isInStock}>
//               <span className="top-key"></span>
//               <span className='text'>
//                 <img src={whatsappicon1} style={{width:'2rem',height:'2rem'}}/>
//                 Order on WhatsApp
//               </span>
//               <span className="bottom-key-1"></span>
//               <span className="bottom-key-2"></span>
//             </button>
//             {showForm && <WhatsAppOrderForm onSubmit={handleFormSubmit} onClose={handleCloseModal} />}
            
//           </div>
//         </div>
//         {/* ----------Add to Cart, Checkout and Order on Whatsapp Buttons ------------*/}




//         <h2 className='description'>Description:</h2>
//         <p>{product.description}</p>
//         <div className='productvideo'>
//           {/* {product.videoLink} */}
//           <iframe
//           width="100%"
//           height="100%"
//           src={product.videoLink} // Firebase se fetched video link
//           title={product.name}
//           frameBorder="0"
//           allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
//           allowFullScreen
//         ></iframe>
//         </div>
//       </div>
//       {/* -----------------Product Detail Section------------------------- */}
      


//       {/* -----------Draw Text 2 Sided line code--------------- */}
//         <div className="text-container">
//           <div className="horizontal-line"></div>
//           <h3>🔥 You May Also Like 🔥</h3>
//           <div className="horizontal-line"></div>
//         </div>
//       {/* -----------Draw Text 2 Sided line code-------------- */}




//       {/* ------------------"You May Also Like" section----------------- */}
//         <Carousel responsive={responsive} containerClass="carousel-container">
//           {suggestedProducts.map(product => (
//             <div key={product.id} className="SuggestionsCard">
//               <Link to={`/product_detail/${product.id}`} className='SuggestionsProductDetailLink'>
//                 <img className="SuggestionsProduct--image" src={product.imageUrl} alt={product.name} />
//                 <h3 className="SuggestionsName">{product.name}</h3>
//                 <p className="SuggestionsPrice">Rs.{product.price}</p>
//               </Link>
//               <button onClick={() => addToCart(product)}>Add to Cart</button>
//             </div>
//           ))}
//         </Carousel>
//       {/* ------------------"You May Also Like" section----------------- */}
     
//     </>
//   );
// }